import { render, staticRenderFns } from "./claim-team.vue?vue&type=template&id=2637940e&"
import script from "./claim-team.vue?vue&type=script&lang=js&"
export * from "./claim-team.vue?vue&type=script&lang=js&"
import style0 from "./claim-team.vue?vue&type=style&index=0&id=2637940e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports